import { format, parseISO } from 'date-fns';

export function formatDate(value: string): string {
  return format(parseISO(value), 'MM/dd/yyyy');
}

export function formatTime(value: string): string {
  return format(parseISO(value), 'h:mm:ss a');
}

export function formatDateTime(value: string): string {
  return format(parseISO(value), 'MM/dd/yyyy h:mm a');
}

export function nowIso(): string {
  return format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");
}
